import { __decorate, __metadata } from "tslib";
import { AppRequest } from '@core/shared/app-request';
import { Expose, IsNumber, Model, ModelId } from '@core/shared/model';
import { AppRequestMethod } from '@core/shared/request';
import { DemoExtensionStatus } from '../enum';
let CheckDemoExtensionStatusResponse = /*#__PURE__*/(() => {
  let CheckDemoExtensionStatusResponse = class CheckDemoExtensionStatusResponse extends Model {};
  __decorate([Expose(), __metadata("design:type", String)], CheckDemoExtensionStatusResponse.prototype, "status", void 0);
  CheckDemoExtensionStatusResponse = __decorate([ModelId("CheckDemoExtensionStatusResponse") // auto-generated by generate-model-ids
  ], CheckDemoExtensionStatusResponse);
  return CheckDemoExtensionStatusResponse;
})();
export { CheckDemoExtensionStatusResponse };
// check is case-insensitive, but note that returned value letters will be as saved in the database!
let CheckDemoExtensionStatusRequest = /*#__PURE__*/(() => {
  let CheckDemoExtensionStatusRequest = class CheckDemoExtensionStatusRequest extends Model {
    static {
      this.Response = CheckDemoExtensionStatusResponse;
    }
  };
  __decorate([Expose(), IsNumber(), __metadata("design:type", Number)], CheckDemoExtensionStatusRequest.prototype, "companyId", void 0);
  CheckDemoExtensionStatusRequest = __decorate([AppRequest('users', 'company-demos/check-extension-status', {
    httpMethod: AppRequestMethod.POST,
    requiredAccessData: ['userId']
  }), ModelId("CheckDemoExtensionStatusRequest") // auto-generated by generate-model-ids
  ], CheckDemoExtensionStatusRequest);
  return CheckDemoExtensionStatusRequest;
})();
export { CheckDemoExtensionStatusRequest };